﻿import {
	Log,
} from '../../shared/tsjs/shared-modules.bundle.js';

document.addEventListener('DOMContentLoaded', () => {
	Log.info('IFrame layout script loaded');
});
